import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import ColliTypeForm from "./ColliTypeForm";
import * as Yup from "yup";
import * as actions from './store/colliTypeActions';
import History from "../../../History";
import { snackActions } from '../../sc-utilities/SnackBar';
import { hasPermission } from "../../sc-utilities";

const ColliTypeCreate = props => {
    const { activeCustomerID, translations, permissions, createColliType, onFetchColliTypeList, onListProductTypes, location } = props;
    const [createData, setCreateData] = useState({ colliTypes: [], productTypes: [], loadingData: true });
    const warehousesObj = location.state

    useEffect(() => {
        const fetchData = async () => {
            // list colliTypes data
            let colliTypes = await onFetchColliTypeList({ ActiveCustomerID: activeCustomerID, q: warehousesObj });
            if (colliTypes instanceof Array && colliTypes.length < 1) {
                snackActions.snackBarComponent("No colli types found, cannot select colli type.", "info");
            }

            // list product types
            let productTypes = await onListProductTypes({ ActiveCustomerID: activeCustomerID, listAll: true });
            if (productTypes instanceof Array && productTypes.length < 1) {
                snackActions.snackBarComponent("No product types found, please create at least one product types first.", "info");
            }

            setCreateData({ loadingData: false, colliTypes: colliTypes, productTypes: productTypes });
        };
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const extractProductColliTypes = selectedProductColliTypes => {
        return selectedProductColliTypes.map(productType => productType.value);
    }

    const extractColliTypes = selectedColliTypes => {
        return selectedColliTypes.map(productType => productType.value);
    }

    const handleSubmit = async data => {
        let requestData = { ...data, ActiveCustomerID: activeCustomerID, HolderColliTypeIDs: extractColliTypes(data.HolderColliTypeIDs), ProductTypeIDs: extractProductColliTypes(data.ProductTypeIDs), ...warehousesObj }
        let result = await createColliType(requestData);
        if (result) {
            History.goBack();
        }
    };

    const cancelHandler = () => {
        History.goBack();
    };

    let initialValues = {
        Name: "",
        Width: "",
        Height: "",
        Length: "",
        MaxWeight: "",
        AllowHolderColliIDNull: false,
        HolderColliTypeIDs: [],
        ProductTypeIDs: []
    };
    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Width: Yup.number().notRequired(),
            Height: Yup.number().notRequired(),
            Length: Yup.number().notRequired(),
            MaxWeight: Yup.number().notRequired(),
            AllowHolderColliIDNull: Yup.boolean(),
            HolderColliTypeIDs: Yup.array().when('AllowHolderColliIDNull', {
                is: (AllowHolderColliIDNull) => AllowHolderColliIDNull !== true,
                then: Yup.array()
                    .required('Field is required')
            })

        },
        FormTitle: translations["create_colli_type"] || "Create colli type",
        ButtonSubmit: hasPermission(permissions, 'colli_type_create') ? {
            Title: translations["save"] || "SAVE"
        } : null,
        ButtonCancel: {
            Title: translations["cancel"] || "Cancel",
            handleCancel: cancelHandler
        }
    };

    return !createData.loadingData ?
        <ColliTypeForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            colliTypes={createData.colliTypes}
            productTypes={createData.productTypes}
            translations={translations}
        ></ColliTypeForm> : null;
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        loading: state.logistic.colliType.creating,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        createColliType: data => dispatch(actions.createColliType(data)),
        onFetchColliTypeList: filter => dispatch(actions.listColliTypes(filter)),
        onListProductTypes: (data) => dispatch(actions.listProductTypes(data))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ColliTypeCreate);


/**
 *  Translations
 *      create_colli_type
 */